import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WeekSelector from '../weekSelector';
import { useTranslation } from 'react-i18next';

const WeeklyStats = () => {
  const [stats, setStats] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [hideInactive, setHideInactive] = useState(false);
  const { t } = useTranslation();

  const fetchStats = (week) => {
    setLoading(true);
    axios.get('https://godrive.com.pl/api/weekly-stats', { params: { week } })
      .then(res => setStats(res.data))
      .catch(err => console.error('Помилка завантаження:', err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (selectedWeek !== null) {
      fetchStats(selectedWeek);
    }
  }, [selectedWeek]);
  const sortData = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedStats = React.useMemo(() => {
    let sortableStats = [...stats];
    if (sortConfig.key !== null) {
      sortableStats.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'ascending' ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'ascending' ? 1 : -1;
        return 0;
      });
    }
    return sortableStats;
  }, [stats, sortConfig]);

  const getSortEmoji = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽';
    }
    return '';
  };

  return (
    <div className="container">
      <h2>{t("weeklystats")}</h2>

      <div className="d-flex align-items-center mb-3">
        <WeekSelector
          selectedWeek={selectedWeek}
          setSelectedWeek={setSelectedWeek}
        />
        <button
          className="btn btn-primary ms-3"
          onClick={() => fetchStats(selectedWeek)}
          disabled={selectedWeek === null || loading}
        >
          {loading ? t("loading") : t("loaddata")}
        </button>


      </div>
      <div className="form-check mt-2">
        <input
          className="form-check-input"
          type="checkbox"
          id="hideInactiveCheckbox"
          checked={hideInactive}
          onChange={() => setHideInactive(prev => !prev)}
        />
        <label className="form-check-label" htmlFor="hideInactiveCheckbox">
          {t("hidedriverswithoutincomings")} Uber / Bolt / FreeNow
        </label>
      </div>
      
      
      {sortedStats.length > 0 && (
        <table className="table table-bordered mt-4">
          <thead className="table-white text-center sticky-top bg-dark" style={{ zIndex: 10 }}>
            <tr>
              <th style={{ cursor: 'pointer' }} onClick={() => sortData('firstName')}>{t("name")}{getSortEmoji('firstName')}</th>
              <th style={{ cursor: 'pointer' }} onClick={() => sortData('lastName')}>{t("surname")}{getSortEmoji('lastName')}</th>
              <th style={{ cursor: 'pointer', width: "12.5%" }} onClick={() => sortData('hasUber')}>Uber{getSortEmoji('hasUber')}</th>
              <th style={{ cursor: 'pointer', width: "12.5%" }} onClick={() => sortData('hasBolt')}>Bolt{getSortEmoji('hasBolt')}</th>
              <th style={{ cursor: 'pointer', width: "12.5%" }} onClick={() => sortData('hasFreeNow')}>FreeNow{getSortEmoji('hasFreeNow')}</th>
              <th style={{ cursor: 'pointer', width: "12.5%" }} onClick={() => sortData('hasDebt')}>{t("debts")}{getSortEmoji('hasDebt')}</th>
              <th style={{ cursor: 'pointer', width: "12.5%" }} onClick={() => sortData('hasExtraFunds')}>{t("extraCosts")}{getSortEmoji('hasExtraFunds')}</th>
              <th style={{ cursor: 'pointer', width: "12.5%" }} onClick={() => sortData('hasPublishedReport')}>
                {t("report")} {t("published").toLocaleLowerCase()}{getSortEmoji('hasPublishedReport')}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedStats
              .filter(user => {
                if (!hideInactive) return true;
                return user.hasUber || user.hasBolt || user.hasFreeNow;
              })
              .map(user => (
                <tr
                  key={user.id}
                  className={
                    user.hasPublishedReport
                      ? "table-success"
                      : (!user.hasUber && !user.hasBolt && !user.hasFreeNow && !user.hasDebt && !user.hasExtraFunds)
                        ? "table-danger"
                        : "table-warning"
                  }
                >

                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.hasUber ? '✅' : '❌'}</td>
                  <td>{user.hasBolt ? '✅' : '❌'}</td>
                  <td>{user.hasFreeNow ? '✅' : '❌'}</td>
                  <td>
                    {user.hasDebt ? '✅' : (
                      <a
                        href={`/admin/driver-debts?openModal=true&driverId=${user.id}&week=${selectedWeek}`}
                        className="text-decoration-none"
                        title={t("newdebt")}
                      >
                        ❌
                      </a>
                    )}
                  </td>
                  <td>
                    {user.hasExtraFunds ? '✅' : (
                      <a
                        href={`/admin/edit-extra-funds?driver_id=${user.id}&week_number=${selectedWeek}`}
                        className="text-decoration-none"
                        title={t("newextracosts")}
                      >
                        ❌
                      </a>
                    )}
                  </td>
                  <td>
                    {user.hasPublishedReport ? (
                      <a
                        href={`/admin/check-reports`}
                        className="text-success text-decoration-none"
                        title={t("checkreport")}
                      >
                        ✅
                      </a>
                    ) : (
                      <a
                        href={`/admin/driver-raport?driverId=${user.id}&week=${selectedWeek}`}
                        className="text-danger text-decoration-none"
                        title={t("createreport")}
                      >
                        ❌
                      </a>
                    )}
                  </td>


                </tr>
              ))}
          </tbody>
        </table>
        
      )}

      {sortedStats.length === 0 && selectedWeek !== null && !loading && (
        <p className="mt-4">{t("noRecords")}</p>
      )}

      {selectedWeek === null && (
        <p className="mt-4">{t("choose")} {t("week").toLocaleLowerCase()} {t("and").toLocaleLowerCase()} {t("press").toLocaleLowerCase()} {t("button").toLocaleLowerCase()} {t("for").toLocaleLowerCase()} {t("check").toLocaleLowerCase()} {t("stats").toLocaleLowerCase()}</p>
      )}
      <div className="alert alert-info mt-4" role="alert">
        <strong>{t("hilightsdesc")}</strong><br />
        <span className="badge bg-success me-2">{t("green")}</span>{t("greendesc")}<br />
        <span className="badge bg-warning text-dark me-2">{t("yellow")}</span>{t("yellowdesc")}<br />
        <span className="badge bg-danger me-2">{t("red")}</span>{t("reddesc")}
      </div>
    </div>
  );
};

export default WeeklyStats;